import React from "react";
import styles from "../style.module.css"

export default function ClassTitle() {
  return (
    <div className={`${styles["row"]} ${styles.rowBox}`}>
      <div className={styles["text_row"]}>classroom name</div>
      <div className={styles["text_row"]}>classroom ID</div>
      <div className={styles["text_row"]}>student</div>
      <div className={styles["text_row"]}>Action</div>
    </div>
  );
}
